// Backend Urls
export const baseUrl = 'https://iconnect-47.herokuapp.com';

// Authentication Urls
export const login = `${baseUrl}/login`;
export const signup = `${baseUrl}/signup`;
export const changePassword = `${baseUrl}/change-password`;

// Message Module Urls
export const getContacts = `${baseUrl}/contacts`;
export const getMessages = `${baseUrl}/messages`;
export const postMessage = `${baseUrl}/message`;
export const postEmojiRecommendation = `${baseUrl}/emoji-recommendation`;

// User Account Urls
export const getInterests = `${baseUrl}/interests`;
export const putInterests = `${baseUrl}/interests`;
export const getProfilePicture = `${baseUrl}/profile-picture`;
export const putProfilePicture = `${baseUrl}/profile-picture`;